<template>
  <div
    :class="{'popdown-open': opened, 'popdown-closed': !opened}"
    class="popdown-card"
    @click="toggle">
    <div class="popdown-inside">
      <span
        v-show="!opened"
        class="icon">
        <i
          
          class="fas fa-arrow-alt-circle-right"/>
      </span>
      <span
        v-show="opened"
        class="icon">
        <i
          class="fas fa-times"/>
      </span>
      <h3 class="special-text purpleish-effect" >{{ title }}</h3>
    </div>
    <div class="popdown-content">
      <div
        class="popdown-content-inner"
        v-html="message"/>
    <!-- <span
      class="icon close-icon"
      @click="toggle"><i class="fas fa-times"/></span> -->
    </div>
  </div>
</template>

<script>
export default {
    props: {
        title: {
            type: [String],
            default: 'There should be a title here, something is broken'
        },
        message: {
            type: [String],
            default: 'There should be a title here, something is broken'
        },
        startOpened: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            opened: false
        }
    },
    created() {
      if (this.startOpened)
        this.opened = true
    },
    methods: {
        toggle() {
            this.opened = !this.opened
        },
        open() {
            if (!this.opened)
                this.opened = true
        }
    }

}
</script>

<style lang="scss">
    .popdown-cards {
        flex-wrap: wrap;
    }
    .popdown-card {
      position: relative;
      margin-bottom: 1rem;
      .icon {
        margin-right: 1.5rem;
          svg {
            color: #BFBFBF;
                font-size: 1.7em;
                cursor: pointer;
            }
        }
    }
    .popdown-inside {
        background-color: #7A6568;
        display: flex;
        align-items: center;
		padding: 0.5rem 1rem;
        cursor: pointer;
        &:hover {
          background: lighten(#7A6568, 10%);
        }
        h3 {
            margin: 0 !important;
            text-transform: uppercase;
            font-size: 1.3125em;
            color: white;
        }
        > .icon {
          svg {
            color: white;
          }
        }
    }
    .popdown-icon {
        max-width: 70px;
        margin-right: 30px;
        cursor: pointer;
        img {
            display: block;
        }
    }
    // .popdown-closed {
    // 	cursor: pointer;
    // }
    // .close-icon {
    //     position: absolute;
    //     right: 15px;
    //     bottom: 12px;
    // }
    .popdown-content {
        max-height: 0;
        position: relative;
        padding: 0 2rem;
        overflow: hidden;
        transition: all 0.5s ease-in-out;
        .popdown-open & {
            max-height: 900px;
        }
    }
    .popdown-content-inner {
        padding: 3rem 1rem 3rem 2rem;
    }
    // .popdown-open {
    // 	height: 100%;
    // }
</style>



// WEBPACK FOOTER //
// assets/js/PopDown.vue